import { useState } from "react";
import { testimonials } from "@/mocks/manga";

export default function TestimonialSection() {
  const [active, setActive] = useState(0);

  const current = testimonials[active];

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 md:gap-16">
          <div className="lg:w-[55%] flex flex-col justify-center">
            <p className="text-xs font-medium text-foreground-500 uppercase tracking-wider">
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-primary-500 mr-2"></span>
              用户原声
            </p>

            <blockquote className="mt-8 md:mt-12">
              <p className="font-serif text-xl md:text-2xl lg:text-3xl text-foreground-900 leading-relaxed italic">
                &ldquo;{current.content}&rdquo;
              </p>
            </blockquote>

            <div className="mt-6 flex items-center gap-3">
              <span className="text-sm font-bold text-foreground-900 font-heading">
                {current.name}
              </span>
              <span className="flex items-center gap-1 px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs">
                <i className="ri-shield-check-line text-xs"></i>
                {current.platform}
              </span>
            </div>

            <div className="mt-8 flex items-center gap-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setActive(index)}
                  className={`w-10 h-1 rounded-full transition-all cursor-pointer ${
                    active === index
                      ? "bg-primary-500 w-12"
                      : "bg-background-300 hover:bg-background-400"
                  }`}
                  aria-label={`查看第${index + 1}条评价`}
                ></button>
              ))}
            </div>
          </div>

          <div className="lg:w-[45%]">
            <div className="aspect-[3/4] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20black%20and%20white%20portrait%20photography%20of%20an%20Asian%20person%20in%20profile%20view%2C%20shoulders%20and%20above%20composition%2C%20looking%20upward%20with%20thoughtful%20expression%2C%20pure%20white%20background%2C%20high%20contrast%20editorial%20style%2C%20clean%20minimal%20aesthetic%2C%20inspired%20by%20manga%20character%20vibe&width=600&height=800&seq=testimonial-portrait-manga&orientation=portrait"
                alt="汗汗漫画读者"
                title="汗汗漫画忠实读者"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}